module.exports = __webpack_public_path__ + "img/arrow-right-round.4c1a8da8.svg";